module.exports = __webpack_public_path__ + "static/norr-logo-c4606c7b9ad0569384f378d18e3228f6.png";